<template>
    <div id="dropdownMenu" class="vrm-button-dropdown">
        <div
            v-for="option in options"
            :key="option.id"
            class="vrm-button-dropdown--option"
            @pointerup="option.action"
        >
            {{ option.name }}
        </div>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import Vue from 'vue';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { Component, Prop } from 'vue-property-decorator';

@Component()
@AngularDirective('vrm-button-dropdown')
export default class VrmButtonDropdown extends Vue {
    @Prop({
        type: Array,
        default: [],
    })
    options;
}
</script>
